import React, { useEffect, useState } from "react";
import { getOrderDetail, getOrderDetailByAdmin } from "../../../../services/LocationService";
import { PriceDetail } from "../../../../models/Order";
import { getPaymentMethodByAdmin } from "../../../../services/UserService";
import { PaymentMethod } from "../../../../models/User";

export default function usePaymentMethod() {
    const [paymentMethod, setPaymentMethod] = useState<PaymentMethod[]>([]);
    const loadPayment = async () => {
        try {
            var res = await getPaymentMethodByAdmin();
            setPaymentMethod(res);
        } catch (err) {
            console.error(err);
        }
    };
    const reload = () => {
        loadPayment();
    };
    useEffect(() => {
            reload();
    }, []);
    return {
        paymentMethod,
        reload
    };
}
